import React, { useContext } from "react";
import clsx from "clsx";
import firebase from "../../firebase";
import { SnackbarAlert } from "../SnackbarAlert";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.warning.light,
    textTransform: "none",
    padding: theme.spacing(1),
    borderRadius: 8,
    fontSize: "1.3em",
    fontWeight: 600,
    letterSpacing: 1,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
  dialog: {
    padding: theme.spacing(1),
    width: "auto",
    color: theme.palette.common.white,
  },
  dialogActions: {
    background: "hsl(0, 0%, 97%)",
  },
  dialogTitle: {
    background: theme.palette.warning.light,
  },
}));

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[50],
    fontSize: 40,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, action, className, classes, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other} className={className}>
      <Typography component="div">
        <Box
          fontSize={24}
          fontWeight="fontWeightBold"
          letterSpacing={0.7}
          p={1}
        >
          {children}
        </Box>
      </Typography>
      {action ? (
        <span>
          <Tooltip
            title="Close"
            enterDelay={300}
            leaveDelay={200}
            enterNextDelay={300}
          >
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={action}
            >
              <CancelRoundedIcon />
            </IconButton>
          </Tooltip>
        </span>
      ) : null}
    </MuiDialogTitle>
  );
});

const VerifyDoctorForm = (props) => {
  const classes = useStyles();
  const { setSnackbarState } = useContext(SnackbarAlert);
  const verifyDoctor = firebase.functions().httpsCallable("verifyDoctor");
  const [isSubmitting, setSubmitting] = React.useState(false);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await verifyDoctor({
        uid: props.id,
      });
      setSubmitting(false);
      props.close();
      setSnackbarState({
        state: true,
        message: "Doctor successfully verified! 👍",
        status: "info",
      });
    } catch (error) {
      //console.log(error);
      setSubmitting(false);
      props.close();
      setSnackbarState({
        state: true,
        message: error.message,
        status: "error",
      });
    }
  };

  return (
    <>
      <DialogTitle
        id="form-dialog-title"
        action={props.close}
        className={clsx(classes.dialog, classes.dialogTitle)}
      >
        Approve Doctor
      </DialogTitle>
      <DialogContent>
        <Typography component="div">
          <Box
            letterSpacing={0.5}
            fontSize={20}
            fontWeight={600}
            p={1}
            className={classes.secondaryText}
          >
            Approve user as verified doctor?
          </Box>
        </Typography>
      </DialogContent>

      <DialogActions className={clsx(classes.dialog, classes.dialogActions)}>
        <Button
          variant="text"
          className={classes.button}
          disabled={isSubmitting}
          onClick={handleSubmit}
          fullWidth
        >
          Approve
        </Button>
      </DialogActions>
    </>
  );
};

export default VerifyDoctorForm;
